import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Stack } from '@mui/system';
import ImageCarousel from './imgCarousel';
import "./details_table.css"



export default function BasicTable({address, floor, rent, deposit, size, images, numBedrooms, lang_id}) {
  if (numBedrooms === 0){
    numBedrooms="studio"
  }

  const rows_fr = [
    {name:"Adresse", value:`${address}`},
    {name:"Chambres", value:`${numBedrooms}`},
    {name:"Etage", value:`${floor}`},
    {name:"Dépôt", value:`${deposit}`},
    {name:"Taille", value:`${size}`},
    {name:"Loyer", value:`${rent}`},
   
];
  const rows = [
    {name:"Address", value:`${address}`},
    {name:"Bedrooms", value:`${numBedrooms}`},
    {name:"Floor", value:`${floor}`},
    {name:"Deposit", value:`${deposit}`},
    {name:"Size", value:`${size}`},
    {name:"Rent", value:`${rent}`},
   
];


const rowsToRender = lang_id === 'fr' ? rows_fr : rows;
  return (
    <>


  <Stack>
 

    <ImageCarousel  images={images} />
 <TableContainer component={Paper} sx={{maxWidth: 500}}>
      <Table sx={{ minWidth: 350 , maxWidth: 600}} aria-label="simple table">
        <TableHead>
        <TableRow sx={{ backgroundColor:'#ffe923' }}>
          <TableCell sx={{fontFamily: 'Verdana'}}>{lang_id === 'fr' ? "Détails de l'appartement" : "Apartment Details"}</TableCell>
          <TableCell sx={{maxWidth: 'content'}}></TableCell>
        </TableRow>
      </TableHead>
      </Table>
      </TableContainer>
    <TableContainer component={Paper} sx={{maxWidth: 500}}>
      <Table sx={{ minWidth: 350 , maxWidth: 600}} aria-label="simple table">
        <TableBody >
          {rowsToRender.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 }, p:1 }}
            >
              <TableCell component="th" scope="row" sx={{borderBottom: 1,fontFamily: 'Verdana', p:1  }}>
                {row.name}
              </TableCell>
              <TableCell sx={{maxWidth: 100, textAlign: 'right', fontFamily: 'Verdana',p:1.5, m:1} } >{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Stack>
    </>
  );
}